<template>
  <GroupFinancialTransfer />
</template>
<script>
import appConfig from '@/app.config'

import GroupFinancialTransfer from '../../../components/dadban/wallet/GroupFinancialTransfer.vue'

export default {
  page: {
    title: 'انتقال گروهی',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'groupFinancialTransfer',
  components: {
    GroupFinancialTransfer,
  },
}
</script>
